import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <header className="privacy-header">
                    <Link to="/" className="back-link">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 12H5" />
                            <path d="M12 19l-7-7 7-7" />
                        </svg>
                        Back to Home
                    </Link>
                    <h1>Privacy Policy</h1>
                    <p className="last-updated">Last updated: January 21, 2026</p>
                </header>

                <div className="privacy-content">
                    <section className="privacy-section">
                        <h2>Overview</h2>
                        <p>
                            Spreadsheetr is designed as a business process automation tool that minimizes personal data collection.
                            We only collect the minimum information necessary to provide our spreadsheet calculation services.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Information We Collect</h2>
                        <h3>Account Information</h3>
                        <ul>
                            <li><strong>Username:</strong> A unique identifier you choose (not your real name)</li>
                            <li><strong>Organization Name:</strong> Your business or organization name</li>
                            <li><strong>Password:</strong> Securely hashed and stored</li>
                        </ul>

                        <h3>Business Data</h3>
                        <ul>
                            <li><strong>Spreadsheet Files:</strong> Excel/CSV files you upload for processing</li>
                            <li><strong>Calculation Results:</strong> Outputs from your business calculations</li>
                            <li><strong>Audit Logs:</strong> Records of system actions for security and compliance</li>
                        </ul>

                        <h3>What We Don't Collect</h3>
                        <ul>
                            <li>Real names, email addresses, or phone numbers</li>
                            <li>Personal demographic information</li>
                            <li>Behavioral tracking or analytics data</li>
                            <li>Marketing or advertising data</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>How We Use Your Information</h2>
                        <ul>
                            <li><strong>Service Provision:</strong> To process your spreadsheet calculations and provide system access</li>
                            <li><strong>Security:</strong> To maintain audit trails and prevent unauthorized access</li>
                            <li><strong>System Administration:</strong> To manage user accounts and organizational access</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>Data Retention</h2>
                        <ul>
                            <li><strong>Active Accounts:</strong> Data retained while your account is active</li>
                            <li><strong>Deleted Accounts:</strong> Personal data deleted within 30 days of account deletion</li>
                            <li><strong>Audit Logs:</strong> Retained for 7 years for compliance purposes (anonymized after account deletion)</li>
                            <li><strong>Business Data:</strong> Retained according to your organization's data retention settings</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>Your Rights</h2>
                        <h3>Account Management</h3>
                        <ul>
                            <li><strong>Access:</strong> View your account information in the user settings</li>
                            <li><strong>Correction:</strong> Update your username or organization name</li>
                            <li><strong>Deletion:</strong> Request account deletion through your admin or contact us</li>
                        </ul>

                        <h3>Data Portability</h3>
                        <p>You can export your business data (spreadsheets, templates, calculation results) at any time through the system interface.</p>
                    </section>

                    <section className="privacy-section">
                        <h2>Data Security</h2>
                        <ul>
                            <li>All data encrypted in transit and at rest</li>
                            <li>Role-based access controls</li>
                            <li>Regular security audits and monitoring</li>
                            <li>Secure authentication and session management</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>Self-Hosting</h2>
                        <p>
                            Spreadsheetr can be deployed on your own infrastructure, giving you complete control over your data.
                            When self-hosted, no data leaves your environment.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Contact Us</h2>
                        <p>
                            For privacy-related questions or to exercise your rights, contact your system administrator
                            or the organization that deployed Spreadsheetr.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Privacy;